export interface Bonus {
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    title: '🎁 BONUS 1 — Guide de Sélection & Compatibilité Domotique™',
    description:
      'Matrices, comparatifs, arbres de décision et checklists pour sélectionner capteurs, éclairage, prises, thermostats, hubs et passerelles selon leur protocole, compatibilité, fonctionnement local ou cloud, évolutivité et besoins réels du projet.',
  },
  {
    title: '🎁 BONUS 2 — 20 Projets Domotiques Pas à Pas™',
    description:
      'Une collection progressive de projets pratiques allant des premières automatisations aux installations multi-zones, avec matériel, prérequis, configuration, automatisations, procédures de test, erreurs fréquentes, variantes et défis pratiques.',
  },
  {
    title: '🎁 BONUS 3 — Domotique Troubleshooting Bible™',
    description:
      'Une méthode complète pour diagnostiquer problèmes d’appairage, connexion, Wi-Fi, Zigbee, appareils hors ligne, automatisations, hubs, mises à jour et intégrations en suivant un processus logique plutôt qu’en essayant des solutions au hasard.',
  },
  {
    title: '🎁 BONUS 4 — Toolkit Domotique Prêt à l’Emploi™',
    description:
      'Checklists, fiches, modèles et documents prêts à utiliser pour analyser une habitation, planifier le projet, sélectionner les équipements, enregistrer les configurations, tester l’installation, documenter les incidents et organiser la maintenance.',
  },
  {
    title: '🎁 BONUS 5 — Domotique Service Starter™',
    description:
      'Un parcours pratique pour structurer vos compétences comme un service : découverte client, analyse des besoins, visite, proposition, sélection du matériel, devis, planification, mise en service, réception, documentation et maintenance.',
  },
]
